import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import { ConnectedProps } from 'mf-shared/types/common';
import { forgotPassword } from '../../state/action-mess';
import {
  otpError as setOtpError,
  showOtp as showOtpAction,
  verifyPasswordOtp,
  generatePasswordOtpRequest,
} from '../../state/forgotPassword/actions';

import AuthTitle from '../Titles/AuthTitle';
import ForgotPasswordForm from './ForgotPasswordForm';
import OtpInput from '../Register/OtpInput/OtpInput';

import styles from './style.css';

function mapStateToProps(state) {
  return {
    data: state,
  };
}

const connector = connect(mapStateToProps);

interface ForgotPasswordProps {
  readonly data?: any;
  readonly history?: any;
  readonly dispatch?: (...args: any[]) => any;
}

interface ForgotPasswordState {
  readonly userInput: string;
}

type Props = ConnectedProps<typeof connector, ForgotPasswordProps>;

class ForgotPassword extends React.Component<Props, ForgotPasswordState> {
  constructor(props: Props) {
    super(props);
    this.state = {
      userInput: '',
    };
  }

  render() {
    const { dispatch } = this.props;
    const { error } = this.props.data.moka;
    const { showOtp, otpError } = this.props.data.forgotPassword;
    return (
      <div
        className={`${styles.root} ${showOtp ? styles['otp-container'] : ''}`}
      >
        {!showOtp && (
          <div className={`${styles['forgot-password-form']}`}>
            <AuthTitle
              title={'Forgot Password'}
              subTitle={
                'Enter your email or phone number to reset your password.'
              }
            />
            <ForgotPasswordForm
              dispatch={dispatch}
              error={error}
              onSubmit={this.handleSubmit}
            />
            <hr className="mt-30px mb-30px" />
            <div className="mt-20px mb-20px" style={{ textAlign: 'center' }}>
              Back to the <Link to="/login">Sign in</Link> or{' '}
              <Link to="/register">Sign up</Link> page
            </div>
          </div>
        )}
        {showOtp && (
          <OtpInput
            timer={showOtp}
            phone={this.state.userInput}
            className={`${styles['otp-style']}`}
            otpError={otpError}
            setOtpError={setOtpError}
            showOtpAction={showOtpAction}
            handleResendOtp={this.handleResendOtp}
            handleBackClick={this.handleBackClick}
            handleOtpSubmit={this.handleOtpSubmit}
          />
        )}
      </div>
    );
  }

  handleResendOtp = (phone: string) => {
    const { dispatch } = this.props;

    dispatch(generatePasswordOtpRequest({ phone }));
  };

  handleBackClick = () => {
    const { dispatch } = this.props;

    dispatch(setOtpError(null));
    dispatch(showOtpAction(false));
  };

  handleOtpSubmit = (code: string) => {
    const { dispatch, data } = this.props;
    const { request_id, token } = data.forgotPassword;

    dispatch(verifyPasswordOtp({ code, request_id, token }));
  };

  handleSubmit = (values) => {
    const { email, captcha } = values;
    let trimEmail = email.trim();

    if (!Number.isNaN(Number(trimEmail))) {
      if (trimEmail[0] === '0') {
        trimEmail = trimEmail.slice(1);
      } else if (trimEmail[0] === '+') {
        trimEmail = trimEmail.slice(3);
      }
    }
    this.setState({ userInput: `+62${trimEmail}` });
    this.props.dispatch(forgotPassword({ email: trimEmail, captcha }));
  };
}

export default connector(ForgotPassword);
